const user_management_list = {
  title: '登録コーチ管理',
  approve_button: "承認",
  reject_button: "拒否",
  search_placeholder: '検索',
  no: '番号',
  user_name: 'アートシフトコーチ',
  email: 'メールアドレス',
  graduation: '卒業期',
  plan: 'プラン名',
  course: 'コース',
  created_date: '登録日',
  dialog: {
    error: {
      title: 'アカウント承認結果のお知らせ',
      user_not_found: 'ご指定のコーチは存在しません。',
    }
  }
}

export default user_management_list